var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSixDots = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C4 1.80964 4.55964 1.25 5.25 1.25C5.94036 1.25 6.5 1.80964 6.5 2.5C6.5 3.19036 5.94036 3.75 5.25 3.75C4.55964 3.75 4 3.19036 4 2.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5C9.5 1.80964 10.0596 1.25 10.75 1.25C11.4404 1.25 12 1.80964 12 2.5C12 3.19036 11.4404 3.75 10.75 3.75C10.0596 3.75 9.5 3.19036 9.5 2.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 7.30964 4.55964 6.75 5.25 6.75C5.94036 6.75 6.5 7.30964 6.5 8C6.5 8.69036 5.94036 9.25 5.25 9.25C4.55964 9.25 4 8.69036 4 8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8C9.5 7.30964 10.0596 6.75 10.75 6.75C11.4404 6.75 12 7.30964 12 8C12 8.69036 11.4404 9.25 10.75 9.25C10.0596 9.25 9.5 8.69036 9.5 8Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5C4 12.8096 4.55964 12.25 5.25 12.25C5.94036 12.25 6.5 12.8096 6.5 13.5C6.5 14.1904 5.94036 14.75 5.25 14.75C4.55964 14.75 4 14.1904 4 13.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5C9.5 12.8096 10.0596 12.25 10.75 12.25C11.4404 12.25 12 12.8096 12 13.5C12 14.1904 11.4404 14.75 10.75 14.75C10.0596 14.75 9.5 14.1904 9.5 13.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSixDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SixDots.fab0ba2fe9e073ff9b73c2d5b1dc19db.svg";